import gql from 'graphql-tag'

export const QUERY = gql`
  query course_projects_index($page: Int!, $perPage: Int!) {
    courseProjects(page: $page, perPage: $perPage) {
      nodes {
        id
        title
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
